import React from "react";
import "../home/home.css";
function Taxexempt() {
  return (
    <section className="section">
      <div className="section-center">
        <article className="activeSlide">
          <p className="title name-t">Tax Exempt</p>
          <h4 className="name-t">990</h4>
          <p className="text text-p">
            Fingerstache umami squid, kinfolk subway tile selvage tumblr man
            braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.Fingerstache umami squid, kinfolk subway tile selvage
            tumblr man braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.Fingerstache umami squid, kinfolk subway tile selvage
            tumblr man braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.Fingerstache umami squid, kinfolk subway tile selvage
            tumblr man braid viral kombucha gentrify fanny pack raclette pok pok
            mustache.
          </p>
        </article>
      </div>
    </section>
  );
}
export default Taxexempt;
